package er.prateek.crossly.data.model

import kotlinx.serialization.Serializable

@Serializable
data class Clue(
    val number: Int,
    val row: Int,
    val col: Int,
    val answer: String,
    val clue: String,
)
